const userTokenKey = "userToken";

export function setUserTokenInLocalStorage(userToken: string): void
{
  localStorage.setItem(userTokenKey, userToken);
}

export function removeUserTokenFromLocalStorage(): void
{
  if(localStorage.getItem(userTokenKey) !== null)
  {
    localStorage.removeItem(userTokenKey);
  }
}

export const getUserToken = (): string|null =>
{
  return localStorage.getItem(userTokenKey);
}